import { createContext, useContext } from 'react';

import { PopoverContextValue } from './types';

const PopoverContext = createContext<null | PopoverContextValue>(null);

const usePopoverContext = (props?: { showError?: boolean }) => {
  const { showError = true } = props || {};
  const context = useContext(PopoverContext);

  if (!context && showError) {
    throw new Error('PopoverContext must be used within Popover');
  }

  return context as PopoverContextValue;
};

export { usePopoverContext };
export default PopoverContext;
